<template>
  <div class="basic-manners">
    <basic-manners-card />
  </div>
</template>

<script>
import BasicMannersCard from '../cards/BasicMannersCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'basic-manners',
  components: {
    BasicMannersCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/services/group-class/basic-manners',
      ogTitle: 'Basic Manners - Rewarding Dog Training',
      ogDescription: 'In this 6 week class, you will learn how to teach your dog skills for calm, polite behaviors inside the house and outside.',
    })
  },
}
</script>

<style lang="scss">
.basic-manners {
  width: 100%;
}
</style>
